angular.module('dnecom')
    .controller('StoreTranslationsSettingsController', StoreTranslationsSettingsController);

StoreTranslationsSettingsController.$inject = ['$http', '$scope', 'wizardModal', 'notifications'];

function StoreTranslationsSettingsController($http, $scope, wizardModal, notifications) {
    let vm = this;
    const store = TemplateData.value('store');
    vm.storeLabels = TemplateData.value('storeLabels');
    vm.defaultLabels = TemplateData.value('defaultLabels');
    for (const [key, value] of Object.entries(vm.storeLabels)) {
        if (Array.isArray(vm.storeLabels[key])) {
            vm.storeLabels[key] = {};
        }
    }
    console.log(vm.storeLabels);
    console.log(vm.defaultLabels);
    vm.openedInputs = [];
    vm.errorInputs = [];
    vm.groups = {
        'home_page': 'Home page',
        'product_page': 'Product page',
        'cart_page': 'Cart page',
        'checkout_page': 'Checkout page',
        'fields_placeholders': 'Fields labels and buttons',
        'upsell_page': 'Upsell page',
        'thank_you_page': 'Thank you page',
        'status_page': 'Order status page',
        'validation_messages': 'Validation messages',
        'search_page': 'Search page and sorting',
    };

    vm.openInput = function (group, key) {
        vm.openedInputs.push(key);
        if (!vm.storeLabels[group] || !vm.storeLabels[group][key]) {
            vm.storeLabels[group][key] = vm.defaultLabels[group][key];
        }
    }

    vm.showInput = function (key) {
        return vm.openedInputs.includes(key);
    }

    vm.saveLabel = function (group, key) {
        let length = vm.defaultLabels[group][key].length * 2;
        if (vm.storeLabels[group] && vm.storeLabels[group][key] && vm.storeLabels[group][key].length <= length) {
            let index = vm.errorInputs.indexOf(key);
            if (index > -1) {
                vm.errorInputs.splice(index, 1);
            }
            let indexOpened = vm.openedInputs.indexOf(key);
            if (indexOpened > -1) {
                vm.openedInputs.splice(indexOpened, 1);
            }
            $scope.$emit('store:trans:changed', vm.storeLabels);
            return;
        }
        let index = vm.errorInputs.indexOf(key);
        if (index == -1) {
            vm.errorInputs.push(key);
        }
    };
    vm.setDefault = function (group, key) {
        if (vm.storeLabels[group] && vm.storeLabels[group][key]) {
            delete vm.storeLabels[group][key];
        }
        $scope.$emit('store:trans:changed', vm.storeLabels);
    };

    vm.setDefaultAll = function () {
        vm.openedInputs = [];
        vm.errorInputs = [];
        vm.storeLabels = {}
        for (const [key, value] of Object.entries(vm.defaultLabels)) {
            vm.storeLabels[key] = {};
        }
        $scope.$emit('store:trans:changed', vm.storeLabels);
    };

    vm.setDefaultGroup = function (group) {
        vm.openedInputs = [];
        vm.errorInputs = [];
        vm.storeLabels[group] = {};
        $scope.$emit('store:trans:changed', vm.storeLabels);
    }

    vm.hasError = function (key) {
        return vm.errorInputs.indexOf(key) > -1;
    }

    vm.saveGroup = function (group) {
        let result = {};
        for (const [key, value] of Object.entries(vm.defaultLabels[group])) {
            if (vm.storeLabels[group] && vm.storeLabels[group][key]) {
                result[key] = vm.storeLabels[group][key];
            }
        }
        $http.post(
            Routing.generate('stores_update_translations', { id: store.id, group: group }),
            result
        )
            .then(function (response) {
                if (response.data.success) {
                    $scope.$emit('store:trans:saved', vm.storeLabels);
                    notifications.success('Labels saved.');
                } else {
                    notifications.danger(response.data.message);
                }
            }, function (response) {
                notifications.danger('Request error.');
            })
    }

    $scope.$on('store:trans:forceSave', function (evnt, data) {
        vm.saveAll();
    })

    $scope.$on('store:trans:revert', function (evnt, data) {
        vm.storeLabels = data;
    })

    vm.saveAll = function () {
        if (vm.errorInputs.length) {
            notifications.danger('Some fields are not valid');
            return;
        }
        let result = {};
        for (const [group, groupLabel] of Object.entries(vm.groups)) {
            for (const [key, value] of Object.entries(vm.storeLabels[group])) {
                if (vm.defaultLabels[group] && vm.defaultLabels[group][key] && vm.defaultLabels[group][key] !== value) {
                    if (!result[group]) {
                        result[group] = {};
                    }
                    result[group][key] = value;
                }
            }
        }
        $http.post(
            Routing.generate('stores_update_translations_all', { id: store.id}),
            result
        )
            .then(function (response) {
                if (response.data.success) {
                    $scope.$emit('store:trans:saved', vm.storeLabels);
                    notifications.success('Labels saved.');
                } else {
                    notifications.danger(response.data.message);
                }
            }, function (response) {
                notifications.danger('Request error.');
            })
    }
}
